import { render, staticRenderFns } from "./TagToolbar.vue?vue&type=template&id=18a2259b"
import script from "./TagToolbar.vue?vue&type=script&lang=js"
export * from "./TagToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports